module.exports = __webpack_public_path__ + "img/logout.404822e1.svg";